import ThreeDotsIcon from "@assets/icons/threeDots"
import styles from "./TableRightSideBarCell.module.css"
import { useState } from "react"
import CrossIcon from "@assets/icons/cross"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
const TableRightSideBarCell = ({ patient }) => {
  const [showPatientOptions, setShowPatientOptions] = useState(false)
  const { ownDetails } = useSelector((state) => state.profile)
  const rightSideBarCellClickHandler = () => {
    setShowPatientOptions((previous) => {
      return !previous
    })
  }
  const { email, firstName } = patient?.local || {}
  const { isEnabled } = ownDetails?.access?.visionPostpaid || {}

  return (
    <div
      className={styles.rightSideBarCell}
      onClick={rightSideBarCellClickHandler}
    >
      {showPatientOptions ? <CrossIcon /> : <ThreeDotsIcon />}

      {showPatientOptions ? (
        <div className={styles.patientOptions}>
          <Link
            to={`/manage-patient-vision/view-patient?_id=${patient._id}`}
            className={styles.patientOption + " " + styles.viewPatient}
          >
            View patient
          </Link>

          {patient.plan !== "active" ? (
            <Link
              to={`/subscribe?email=${email}&name=${firstName}&isEnabled=${isEnabled}`}
              className={styles.patientOption + " " + styles.viewPatient}
            >
              Activate user
            </Link>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default TableRightSideBarCell
